import { Box, Typography } from '@mui/material';
import { Button } from '../../../../Button';
import React from 'react';
import { AddendumContent } from './addendum-content.component';
import { useAddendaBySessionIdQuery } from '@uplift/queries';
import { useCurrentuser } from '@uplift/contexts';
import { AddendumModal } from './addendum-modal.component';
import { Session } from '@uplift/api';
import { TimeRange } from '@uplift/types';

export type AddendumContainerProps = {
  session: Session;
  patientId: string;
  providerId: string;

  noteTime: TimeRange;
  mentalStatusExamNote?: string;
};

export const AddendumContainer: React.VFC<AddendumContainerProps> = ({ session, patientId, providerId, noteTime, mentalStatusExamNote }) => {
  const me = useCurrentuser();
  const [ modalOpen, setModalOpen ] = React.useState<boolean>(false);
  const { data: addenda = [] } = useAddendaBySessionIdQuery(session?.id, { enabled: !!session?.id });
  const title = addenda.length ? 'Addendum' : '';
  const isPrimary = me?.id === providerId;
  const handleAddendumOpen = () => {
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  return (
    <Box display="flex" gap="1rem" flexDirection="column">
      <Box display="flex" flexDirection="row" justifyContent="space-between" px={3} py={2}>
        <Box>
          <Typography variant="h4" color="textPrimary">{title}</Typography>
        </Box>
        {isPrimary && (
          <Button
            variant="outlined"
            onClick={handleAddendumOpen}
          >Add Addendum
          </Button>
        )}
      </Box>
      {addenda?.map(addendum => (
        <AddendumContent key={addendum.id} addendum={addendum} providerId={providerId} />
      ))}
      <AddendumModal
        open={modalOpen}
        onClose={handleModalClose}
        session={session}
        patientId={patientId}
        noteTime={noteTime}
        mentalStatusExamNote={mentalStatusExamNote}
      />
    </Box>
  );
};
